import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { translate } from './translateFunction'; // Import the translate funct  ion

const AdminRole = () => {
  const [roles, setRoles] = useState([]);
  const [editingRole, setEditingRole] = useState(null);
  const [deletingRoleId, setDeletingRoleId] = useState(null);

  const [translations, setTranslations] = useState({
    roleManagement: '',
    roleNameLabel: '',
    actionsLabel: '',
    editButton: '',
    deleteButton: '',
    confirmDeleteButton: '',
    cancelButton: '',
    saveButton: '',
    cancelEditButton: '',
    roleDescLabel: '',
  });

  // Load translations when the component mounts
  useEffect(() => {
    const loadTranslations = async () => {
      const roleManagement = await translate(110);
      const roleNameLabel = await translate(111);
      const actionsLabel = await translate(112);
      const editButton = await translate(113);
      const deleteButton = await translate(114);
      const confirmDeleteButton = await translate(115);
      const cancelButton = await translate(116);
      const saveButton = await translate(117);
      const cancelEditButton = await translate(118);
      const roleDescLabel = await translate(419);

      setTranslations({
        roleManagement,
        roleNameLabel,
        actionsLabel,
        editButton,
        deleteButton,
        confirmDeleteButton,
        cancelButton,
        saveButton,
        cancelEditButton,
        roleDescLabel,
      });
    };

    loadTranslations();
  }, []);

  const getCurrentLanguage = () => {
    return localStorage.getItem('language') || 'de';
  };

  const fetchRoles = useCallback(async () => {
    const languageCode = getCurrentLanguage();

    try {
      const response = await axios.get('/api/admin/roles', {
        params: { languageCode },
      });

      setRoles(response.data);
    } catch (error) {
      console.error('Fehler beim Abrufen der Rollen:', error);
    }
  }, []);

  useEffect(() => {
    fetchRoles();
  }, [fetchRoles]);

  const confirmDelete = (roleId) => {
    setDeletingRoleId(roleId);
  };

  const cancelDelete = () => {
    setDeletingRoleId(null);
  };

  const handleDeleteRole = async (roleId) => {
    try {
      await axios.delete(`/api/admin/roles/${roleId}`);
      setRoles(roles.filter((role) => role.rolesID !== roleId));
    } catch (error) {
      console.error('Fehler beim Löschen der Rolle:', error);
    } finally {
      setDeletingRoleId(null);
    }
  };

  const handleSaveRole = async () => {
    if (!editingRole.rolesName.trim()) {
      alert('Der Rollenname darf nicht leer sein.');
      return;
    }

    try {
      const { rolesID, rolesName } = editingRole;
      await axios.put(`/api/admin/roles/${rolesID}`, { rolesName });
      setRoles(roles.map((role) => (role.rolesID === rolesID ? editingRole : role)));
    } catch (error) {
      console.error('Fehler beim Speichern der Rolle:', error);
    } finally {
      setEditingRole(null);
    }
  };

  return (
    <div className="mb-5">
      <h3>{translations.roleManagement}</h3>
      {editingRole && (
        <div className="mb-5">
          <h3>{translations.roleNameLabel}</h3>
          <form onSubmit={handleSaveRole}>
            <div className="form-group">
              <label>{translations.roleNameLabel}</label>
              <input
                type="text"
                className="form-control"
                value={editingRole.rolesName}
                onChange={(e) => setEditingRole({ ...editingRole, rolesName: e.target.value })}
              />
            </div>
            <button type="button" className="btn btn-primary" onClick={handleSaveRole}>
              {translations.saveButton}
            </button>
            <button
              type="button"
              className="btn btn-secondary ml-2"
              onClick={() => setEditingRole(null)}
            >
              {translations.cancelEditButton}
            </button>
          </form>
        </div>
      )}
      <table className="table">
        <thead>
          <tr>
            <th>{translations.roleNameLabel}</th>
            <th>{translations.roleDescLabel}</th>
            <th>{translations.actionsLabel}</th>
          </tr>
        </thead>
        <tbody>
          {roles.map((role) => (
            <tr key={role.rolesID}>
              <td>{role.translatedName}</td>
              <td>{role.translatedDescription}</td>
              <td>
                <button className="btn btn-primary" onClick={() => setEditingRole(role)}>
                  {translations.editButton}
                </button>
                {deletingRoleId === role.rolesID ? (
                  <>
                    <button
                      className="btn btn-danger mr-2"
                      onClick={() => handleDeleteRole(role.rolesID)}
                    >
                      {translations.confirmDeleteButton}
                    </button>
                    <button className="btn btn-secondary" onClick={cancelDelete}>
                      {translations.cancelButton}
                    </button>
                  </>
                ) : (
                  <button className="btn btn-danger" onClick={() => confirmDelete(role.rolesID)}>
                    {translations.deleteButton}
                  </button>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>


    </div>
  );
};

export default AdminRole;
